
/**
 * 权限检查核心逻辑
 * @param {string|string[]} value 需要检查的权限 code
 * @returns {boolean} 是否有权限
 */
export function checkPermission(value) {
  if (!value) return true;

  const uiStr = localStorage.getItem('userInfo') || '{}';
  let ui = {};
  try {
    ui = JSON.parse(uiStr);
  } catch (e) {
    ui = {};
  }

  // 如果是管理员，直接拥有所有权限
  if (ui.is_admin == 1) {
    return true;
  }

  // 获取当前用户的权限列表
  const perms = Array.isArray(ui && ui.permission) ? ui.permission : [];
  // 规范化处理，去除空白
  const norm = (v) => (v == null ? '' : String(v).trim());
  const allowSet = new Set((perms || []).map((v) => norm(v)));

  if (Array.isArray(value)) {
    // 如果是数组，只要满足其中一个即可 (OR 逻辑)
    return value.some((v) => allowSet.has(norm(v)));
  } else {
    // 单个字符串
    return allowSet.has(norm(value));
  }
}

/**
 * Vue 自定义指令 v-permission
 */
export const permissionDirective = {
  mounted(el, binding) {
    const { value } = binding;
    if (value) {
      const hasPerm = checkPermission(value);
      if (!hasPerm) {
        // 移除元素
        el.parentNode && el.parentNode.removeChild(el);
      }
    }
  },
  // 可能需要在更新时也检查？通常权限在会话期间不变，但在某些动态场景下可能需要 updated 钩子。
  // 考虑到性能和常规用法，mounted 通常足够。如果用户信息更新，通常会刷新页面。
};
